import { createTheme } from '@material-ui/core/styles';
// import green from '@material-ui/core/colors/green';
import '@openfonts/montserrat_latin';
import '@openfonts/montserrat-alternates_latin';

import "assets/scss/material-kit-react.scss?v=1.4.0"; //initialize stylesheets
import '@openfonts/montserrat_latin';
import '@openfonts/montserrat-alternates_latin';

const theme = createTheme({
  // palette: {
  //   primary: {
  //     main: "#370073",
  //   },
  //   secondary: {
  //     main: green[500],
  //   },
  // },
  typography: {
    fontFamily: [
        'Montserrat',
        'sans-serif'
      ].join(','),
    },
});

export default theme;